module.exports = __webpack_public_path__ + "img/IMG_1458_L_Foamcore.258bb8e0.jpg";